import React from 'react'
import styled, { css } from 'styled-components'

const Text = styled.span`
  ${({ line }) =>
    line === 1
      ? css`
          display: inline-block;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : css`
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: ${line};
        `}
`

export default React.memo(
  ({ children, line = 1, as, className, 'data-test-id': dataTestId }) => (
    <Text line={line} as={as} className={className} data-test-id={dataTestId}>
      {children}
    </Text>
  )
)
